type EventMessageProps = {
  content: string;
};

export const EventMessage = ({ content }: EventMessageProps) => {
  return (
    <p className="mx-auto max-w-md rounded-full bg-surface-sunken px-4 py-2 text-center text-sm font-medium text-content-secondary">
      {content}
    </p>
  );
};
